import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AdobeLaunchService } from '../shared/services/adobe-launch.service';
import { PAGE_TITLES, resolveSupportedLang } from '../shared/config/localized-paths';
import { CommonFeatureCardConfig } from './common-feature-card/common-feature-card.interface';
import { NIC_INTRO_BANNER_ASSETS } from './nic.content';

@Component({
  selector: 'app-nic',
  templateUrl: './nic.component.html',
  styleUrls: ['./nic.component.scss'],
})
export class NicComponent implements OnInit {
  public readonly introBannerAssets = NIC_INTRO_BANNER_ASSETS;
  public readonly nicWebsiteUrl = 'https://nic.councilforeconed.org/';

  public readonly teacherOptionCardConfig: CommonFeatureCardConfig = {
    imageSrc: '/assets/images/nic-option1-icon.svg',
    imageAltKey: 'nic.cards.option1.imageAlt',
    headingKey: 'nic.cards.option1.heading',
    chipLabelKey: 'nic.cards.option1.chip',
    descriptionLineKeys: [
      'nic.cards.option1.descriptionLine1',
      'nic.cards.option1.descriptionLine2',
    ],
    subheadingKey: 'nic.cards.option1.resourcesTitle',
    resourceItems: [
      {
        labelKey: 'nic.cards.option1.resource1',
        href: 'nic.cards.option1.resource1Href',
      },
      {
        labelKey: 'nic.cards.option1.resource3',
        href: 'nic.cards.option1.resource3Href',
      },
    ],
  };

  public readonly noTeacherOptionCardConfig: CommonFeatureCardConfig = {
    imageSrc: '/assets/images/nic-option2-icon.svg',
    imageAltKey: 'nic.cards.option2.imageAlt',
    headingKey: 'nic.cards.option2.heading',
    chipLabelKey: 'nic.cards.option2.chip',
    descriptionLineKeys: ['nic.cards.option2.descriptionLine1'],
    lessonLibraryPrefixKey: 'nic.cards.option2.lessonLibraryPrefix',
    lessonLibraryLinkKey: 'nic.cards.option2.lessonLibraryLink',
    lessonLibrarySuffixKey: 'nic.cards.option2.lessonLibrarySuffix',
    lessonLibraryRoute: '/learning-library',
    subheadingKey: 'nic.cards.option2.sessionsTitle',
    sessionItems: [
      {
        dateKey: 'nic.cards.option2.sessionDate1',
        ariaDateKey: 'nic.cards.option2.sessionAriaDate1',
        hrefKey: 'nic.cards.option2.sessionHref1',
        timeKey: 'nic.cards.option2.sessionTime1',
      },
      {
        dateKey: 'nic.cards.option2.sessionDate2',
        ariaDateKey: 'nic.cards.option2.sessionAriaDate2',
        hrefKey: 'nic.cards.option2.sessionHref2',
        timeKey: 'nic.cards.option2.sessionTime2',
      },
      {
        dateKey: 'nic.cards.option2.sessionDate3',
        ariaDateKey: 'nic.cards.option2.sessionAriaDate3',
        hrefKey: 'nic.cards.option2.sessionHref3',
        timeKey: 'nic.cards.option2.sessionTime3',
      },
      {
        dateKey: 'nic.cards.option2.sessionDate4',
        ariaDateKey: 'nic.cards.option2.sessionAriaDate4',
        hrefKey: 'nic.cards.option2.sessionHref4',
        timeKey: 'nic.cards.option2.sessionTime4',
      },
      {
        dateKey: 'nic.cards.option2.sessionDate5',
        ariaDateKey: 'nic.cards.option2.sessionAriaDate5',
        hrefKey: 'nic.cards.option2.sessionHref5',
        timeKey: 'nic.cards.option2.sessionTime5',
      },
      {
        dateKey: 'nic.cards.option2.sessionDate6',
        ariaDateKey: 'nic.cards.option2.sessionAriaDate6',
        hrefKey: 'nic.cards.option2.sessionHref6',
        timeKey: 'nic.cards.option2.sessionTime6',
      },
      {
        dateKey: 'nic.cards.option2.sessionDate7',
        ariaDateKey: 'nic.cards.option2.sessionAriaDate7',
        hrefKey: 'nic.cards.option2.sessionHref7',
        timeKey: 'nic.cards.option2.sessionTime7',
      },
    ],
    sessionButtonLabelKey: 'nic.cards.option2.buttonLabel',
    sessionButtonHref: 'nic.cards.option2.buttonHref',
    contactLinkKey: 'nic.cards.option2.linkText',
    contactSuffixKey: 'nic.cards.option2.contactSuffix',
    contactRoute: '/aboutus',
    privacyPrefixKey: 'nic.cards.option2.privacyPrefix',
    privacyLinkKey: 'nic.cards.option2.privacyLink',
    privacySuffixKey: 'nic.cards.option2.privacySuffix',
    privacyRoute: '/studentprivacy',
  };

  constructor(
    private readonly adobeLaunchService: AdobeLaunchService,
    private readonly translateService: TranslateService,
  ) { }

  ngOnInit(): void {
    const lang = resolveSupportedLang(this.translateService.currentLang);
    this.adobeLaunchService.trackPageView({
      pageTitle: PAGE_TITLES[lang].nic,
    });
  }
}
